import React from "react";
import { cn } from "@/lib/utils";

/**
 * ProfileTemplatePicker — choose a predefined profile or "custom".
 * Props:
 *   templates        : [{ key, name, emoji, description, defaults }]
 *   selectedKey      : currently selected key
 *   onSelect(tmpl)   : callback with the selected template object
 *   disabled         : boolean
 */
export default function ProfileTemplatePicker({
  templates = [],
  selectedKey = null,
  onSelect,
  disabled = false,
}) {
  return (
    <div
      className="grid grid-cols-2 gap-2 sm:grid-cols-3 lg:grid-cols-5"
      data-testid="profile-template-picker"
      role="radiogroup"
      aria-label="Profils prédéfinis"
    >
      {templates.map((t) => {
        const selected = selectedKey === t.key;
        return (
          <button
            key={t.key}
            type="button"
            role="radio"
            aria-checked={selected}
            disabled={disabled}
            onClick={() => onSelect?.(t)}
            data-testid={`template-option-${t.key}`}
            className={cn(
              "group relative flex flex-col items-start gap-1 rounded-lg border p-3 text-left transition-all",
              selected
                ? "border-brand-gold bg-accent/40 shadow-sm ring-2 ring-brand-gold/40"
                : "border-border bg-card hover:border-brand-gold/50 hover:bg-accent/20",
              disabled && "cursor-not-allowed opacity-50"
            )}
          >
            <span className="text-2xl leading-none" aria-hidden="true">
              {t.emoji}
            </span>
            <span className="text-sm font-semibold">{t.name}</span>
            <span className="line-clamp-2 text-[11px] leading-snug text-muted-foreground">
              {t.description}
            </span>
            {selected && (
              <span className="absolute right-2 top-2 h-2 w-2 rounded-full bg-brand-gold" />
            )}
          </button>
        );
      })}
    </div>
  );
}
